































import { Vue, Component, Prop } from 'vue-property-decorator'
import { DialogMain } from '@/components/index'
import { SystemList, SystemAdd, SystemDetail, SystemUpdata } from '@/api/System'
import { SystemSettings } from '@/types/System'
import { EmptyForm } from '@/utils/emptyForm'
import Head from './components/Head/index.vue'
import Card from './components/Card/index.vue'
@Component({
  components: {
    DialogMain,
    Head,
    Card,
  },
})
export default class Main extends Vue {
  /**
   * systemList  侧边栏接口数据
   */
  systemList: any =[]

  /**
   * dialogVisible
   *  Dialog状态
   */
  dialogVisible: boolean = false;

  /**
   * 状态
   *    Add or Updata 默认Add
   */
  dialogStatus = 'add'

  /**
   * Dialog 表单数据
   */
  dialogForm: SystemSettings = {
    name: '',
    code: ''
  };
  // 侧边栏高亮
id:any = null
/**
   * 添加业务
   * createSystem
   */
createSystem() {
  this.dialogStatus = 'add'
  this.dialogVisible = true
}

/**
   * Dialog确认按钮点击
   *   Add or Edit
   */
async handleConfirm() {
  const { dialogForm } = this
  if (this.dialogStatus === 'add') {
    await SystemAdd(dialogForm)
  } else {
    await SystemUpdata(dialogForm)
  }
  this.emptyForm()
  this.dialogVisible = false
  this.getSystemList()
}

/**
   * Dialog取消按钮
   *  清空表单
   *  关闭 Dialog
   */
handleClose() {
  this.emptyForm()
  this.dialogVisible = false
}

/**
   * 清空表单，防止新增时显示编辑内容
   */
emptyForm() {
  EmptyForm(this.dialogForm)
}

/**
   * 点击卡片触发外部事件，
   *  右侧表格刷新
   */
handleClickCard(id:number) {
  this.id = id
  this.$emit('on-handle-click-card', id)
}

/**
   *
   * 点击编辑，
   *  数据回填
   */
async handleEditCard(id:any) {
  const { data } = await SystemDetail(id)
  this.dialogForm = data
  this.dialogStatus = 'updata'
  this.dialogVisible = true
}

created() {
  this.getSystemList()
}

/**
   * 左侧列表查询
   */
async getSystemList() {
  const { data } = await SystemList()
  this.systemList = data

  /**
     * 首次查询
     */

  if (data.length > 0) {
    this.handleClickCard(data[0].id)
  }
}
}
